export const PRODUCTS_STATUS_QUERY_KEY = ['products-status'] as const;
